import { createPostEndpoint } from '@sonar-software/sonar-http';

export type PostSalesforceAuthLinkRequest = {
    code: string;
    customerId?: number;
    organizationId?: number;
};

export type PostSalesforceAuthLinkResponse = {
    id: number;    
    instanceUrl: string;
    name: string;
    salesforceUsername: string;
    sandbox: boolean;
    updatedUserAccessToken?: string;
};

export const postLinkOrganization = createPostEndpoint<PostSalesforceAuthLinkRequest, PostSalesforceAuthLinkResponse>(
	'/api/v3/salesforce/auth/link',
);
